import { SvgIcon, SvgIconProps } from "@mui/material";

const BackIconGivency = (props: SvgIconProps) => (
  <SvgIcon
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M14 20H26M14 20L17.5 16.5M14 20L17.5 23.5" stroke="black" />
  </SvgIcon>
);

export default BackIconGivency;
